exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message-fee .box-card{width:330px;margin-right:20px;float:left}.message-fee .box-card .wraper{margin-right:-20px}.message-fee .el-radio.is-bordered+.el-radio.is-bordered{margin-left:0;float:left}.message-fee .el-radio{margin-left:0;margin-right:15px;margin-bottom:20px;width:135px}.message-fee .el-input-number{width:290px}.message-fee .el-button--primary{width:290px;margin-top:20px}.message-fee .el-dialog__body{padding:10px}.message-fee .el-dialog__footer{text-align:center}.message-fee .el-dialog__footer .el-button--primary{margin-top:0;width:300px}", ""]);

// exports
